<template>
    <div class="page-layout" :class="[{'no-header':!hasHeader},{'no-footer':!hasFooter},language]">
        <Header v-if="hasHeader"/>
        <div class="page-content">
            <transition>
                <keep-alive>
                    <router-view/>
                </keep-alive>
            </transition>
        </div>
        <slot></slot>
        <Footer v-if="hasFooter"/>
        <back-to-top></back-to-top>
    </div>
</template>

<script>
    import Header from '@/components/header/Index.vue'
    import Footer from '@/components/footer/Index.vue'
    import BackToTop from '@/components/BackTop.vue'

    export default {
        data() {
            return {
                hasHeader:false,
                hasFooter:false,
            }
        },
        watch:{
          $route(to){
              this.hasHeader = !to.meta.header_hide;
              this.hasFooter = !to.meta.footer_hide;
          }
        },
        computed:{
            language(){
                return this.$store.state.base.language
            }
        },
        components: {
            Header,
            Footer,
            BackToTop
        }
    }
</script>

<style lang="scss" scoped>
    .page-layout{
        height: 100%;
        &.no-footer {
            .page-content{
                padding-bottom: 0;
            }

        }
        &.no-header {
            .page-content{
                padding-top: 0;
            }
        }
    }
    .page-content{
        padding-bottom: $footer-height;
        min-height: 100%;

    }
</style>
